import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8af41bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contractid" }
const _hoisted_2 = {
  key: 1,
  class: "bg-white px-6 py-4 border flex flex-col justify-center items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка...", -1))
const _hoisted_4 = { class: "contractid__header" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "contractid__container" }
const _hoisted_7 = { class: "mb-4 flex items-center justify-between" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "ID", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Дата договора", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Номер договора в реестре", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Подразделение", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Компания", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "БИН", -1))
const _hoisted_15 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "font-semibold"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Инициатор", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Дата добавления записи", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Кто добавил запись", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Комментарий", -1))
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state_modal.is_open)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: _ctx.getModalTitle,
          loading: _ctx.state_modal.is_loading,
          onCancel: _ctx.cancelModal,
          onConfirm: _ctx.confirmModal
        }, {
          default: _withCtx(() => [
            (_ctx.state_modal.is_status)
              ? (_openBlock(), _createBlock(_component_the_select, {
                  key: 0,
                  value: _ctx.state_modal.statusId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state_modal.statusId) = $event)),
                  "is-invalid": _ctx.state_modal$.statusId.$error,
                  "validation-errors": _ctx.state_modal$.statusId.$errors,
                  placeholder: "Статус",
                  loading: _ctx.data_state.statuses.is_loading,
                  options: _ctx.data_state.statuses.list,
                  failed: _ctx.data_state.statuses.is_failed,
                  "error-text": "При получении списка произошла ошибка",
                  "infinite-scroll": "",
                  onRefresh: _ctx.loadStatuses
                }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh"]))
              : _createCommentVNode("", true),
            (_ctx.isComment)
              ? (_openBlock(), _createBlock(_component_the_input, {
                  key: 1,
                  class: "mt-3",
                  value: _ctx.state_modal.comment,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state_modal.comment) = $event)),
                  placeholder: "Введите комментарий",
                  "is-invalid": _ctx.state_modal$.comment.$error,
                  "validation-errors": _ctx.state_modal$.comment.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_loader, { class: "mt-1 primary" })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_page_title, {
              title: `Договор № ${_ctx.state.contract.number}`
            }, null, 8, ["title"]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.havePermissions(['contract-register-update']))
                ? (_openBlock(), _createBlock(_component_the_button, {
                    key: 0,
                    class: "primary small mr-2",
                    onClick: _ctx.goEdit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Редактировать запись ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_button_dropdown, {
                class: "w-min",
                title: "Выбрать действие",
                placement: "bottom",
                "allowed-placements": ['bottom']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, {
                    class: "text small primary",
                    onClick: _ctx.onStatus
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Изменить статус ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_the_button, {
                    class: "text small primary",
                    onClick: _ctx.onComment
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить комментарий ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_the_button, {
                class: "primary text small",
                onClick: _ctx.goRegister
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Перейти к реестру ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_page_title, { title: "Общая информация" })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.id), 1),
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.contract.date)), 1),
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.number), 1),
              _hoisted_12,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.subdivisionName), 1),
              _hoisted_13,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.companyName), 1),
              _hoisted_14,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.companyBin), 1),
              (_ctx.state.contract.type)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Тип договора"))
                : _createCommentVNode("", true),
              (_ctx.state.contract.type)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.state.contract.type.name), 1))
                : _createCommentVNode("", true),
              (_ctx.state.contract.status)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Статус договора в реестре "))
                : _createCommentVNode("", true),
              (_ctx.state.contract.status)
                ? (_openBlock(), _createBlock(_component_cheap, {
                    key: 3,
                    class: _normalizeClass(["small", _ctx.getStatusColor(_ctx.state.contract.status.id)]),
                    style: { width: 'fit-content' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.contract.status.name), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              _hoisted_18,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.initiatorEmail), 1),
              _hoisted_19,
              _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.contract.createdAt)), 1),
              _hoisted_20,
              _createElementVNode("p", null, _toDisplayString(_ctx.state.contract.createdByEmail), 1),
              _hoisted_21,
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.contract.comments, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `comment-${i}`,
                    class: "grid grid-cols-2 gap-3"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(item.comment), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(item.createdAt), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 64))
  ]))
}